var map = {
  "./assets/favicons-sandbox/android-chrome-192x192.png": "392455",
  "./assets/favicons-sandbox/android-chrome-512x512.png": "181055",
  "./assets/favicons-sandbox/apple-touch-icon-120x120.png": "985323",
  "./assets/favicons-sandbox/apple-touch-icon-152x152.png": "650495",
  "./assets/favicons-sandbox/apple-touch-icon-180x180.png": "54655",
  "./assets/favicons-sandbox/apple-touch-icon-60x60.png": "758163",
  "./assets/favicons-sandbox/apple-touch-icon-76x76.png": "272989",
  "./assets/favicons-sandbox/apple-touch-icon.png": "490544",
  "./assets/favicons-sandbox/browserconfig.xml": "982478",
  "./assets/favicons-sandbox/favicon-16x16.png": "193391",
  "./assets/favicons-sandbox/favicon-32x32.png": "993703",
  "./assets/favicons-sandbox/favicon-alert-16x16.png": "542850",
  "./assets/favicons-sandbox/favicon-alert-32x32.png": "135798",
  "./assets/favicons-sandbox/favicon-alert.ico": "714789",
  "./assets/favicons-sandbox/favicon.ico": "969496",
  "./assets/favicons-sandbox/mstile-144x144.png": "841135",
  "./assets/favicons-sandbox/mstile-150x150.png": "514955",
  "./assets/favicons-sandbox/mstile-310x150.png": "66581",
  "./assets/favicons-sandbox/mstile-310x310.png": "552175",
  "./assets/favicons-sandbox/mstile-70x70.png": "964753",
  "./assets/favicons-sandbox/safari-pinned-tab.svg": "620016",
  "./assets/favicons-sandbox/site.webmanifest": "466757",
  "./assets/favicons-sandbox/upc-favicon.ico": "618229"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 48560;
